export const copy = {
  errors: {
    selectSuggestedAddress: 'Please select an address from the suggested options',
    invalidAddress: 'Please enter a valid address',
    invalidAddressForState: (stateName: string) => `Please enter a valid address in ${stateName}`,
    utilityServiceAreaMismatch:
      "The address you entered does not match the selected utility's service area. Please update your address",
    addressValidationFailed: 'There was an error validating your address. Please try again.',
    lmiNotEligible:
      'The address you entered is not in a qualifying low-to-moderate income area. Please enter an LMI-eligible address.',
    lmiCheckFailed:
      'There was an error checking LMI eligibility for your address. Please try again.',
  },
};
